import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-user-status-dialog',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  template: `
    <div class="dialog-container">
      <div class="dialog-header">
        <mat-icon class="dialog-icon" [class.warning]="!data.newStatus" [class.success]="data.newStatus">
          {{ data.newStatus ? 'lock_open' : 'lock' }}
        </mat-icon>
        <h2 class="dialog-title">
          {{ data.newStatus ? 'Activer' : 'Révoquer' }} l'utilisateur
        </h2>
      </div>

      <div class="dialog-content">
        <div class="user-info">
          <div class="info-item">
            <strong>Nom :</strong> {{ data.user.firstName }} {{ data.user.lastName }}
          </div>
          <div class="info-item">
            <strong>Email :</strong> {{ data.user.email || 'Non renseigné' }}
          </div>
          <div class="info-item">
            <strong>Statut actuel :</strong>
            <span class="status-badge" [class.active]="data.user.enabled" [class.inactive]="!data.user.enabled">
              {{ data.user.enabled ? 'Actif' : 'Inactif' }}
            </span>
          </div>
        </div>

        <p class="confirmation-message">
          Voulez-vous vraiment {{ data.newStatus ? 'activer' : 'révoquer' }} l'accès de 
          <strong>{{ data.user.firstName }} {{ data.user.lastName }}</strong> ?
        </p>
      </div>

      <div class="dialog-actions">
        <button mat-stroked-button (click)="onCancel()" class="cancel-btn">
          Annuler
        </button>
        <button mat-raised-button 
                [color]="data.newStatus ? 'primary' : 'warn'" 
                (click)="onConfirm()"
                class="confirm-btn">
          {{ data.newStatus ? 'Activer' : 'Révoquer' }}
        </button>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .dialog-container {
      padding: 20px;
      max-width: 450px;
      border-radius: 12px;
    }

    .dialog-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e0e0e0;
    }

    .dialog-icon {
      font-size: 32px;
      width: 32px;
      height: 32px;
    }

    .dialog-icon.warning {
      color: #f44336;
    }

    .dialog-icon.success {
      color: #4caf50;
    }

    .dialog-title {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 600;
      color: #2c3e50;
    }

    .dialog-content {
      margin-bottom: 25px;
    }

    .user-info {
      background: #f8f9fa;
      padding: 15px;
      border-radius: 8px;
      margin-bottom: 20px;
    }

    .info-item {
      margin-bottom: 8px;
      display: flex;
      gap: 8px;
    }

    .info-item:last-child {
      margin-bottom: 0;
    }

    .status-badge {
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 0.8rem;
      font-weight: 500;
    }

    .status-badge.active {
      background: #e8f5e9;
      color: #2e7d32;
    }

    .status-badge.inactive {
      background: #ffebee;
      color: #c62828;
    }

    .confirmation-message {
      margin: 0;
      line-height: 1.5;
      color: #546e7a;
    }

    .dialog-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }

    .cancel-btn {
      border-color: #b0bec5;
      color: #546e7a;
    }

    .confirm-btn {
      min-width: 100px;
    }
  `]
})
export class UserStatusDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UserStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: any, newStatus: boolean }
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}